"use strict";
/**
 * @example
 *    setA = [1,2,3];
 *    setB = [2,3,4];
 *    diff(setA, setB); // [1]
 *    diff(setB, setA); // [4]
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.diffSet = void 0;
function diffSet(setA, setB) {
    if (!Array.isArray(setA) || !Array.isArray(setB)) {
        throw new Error(`Invalid arguments passed to "diffSet" helper
      ${JSON.stringify({
            setA,
            setB,
        }, null, 2)}
      `);
    }
    return setA.filter(valueA => !setB.find(valueB => valueA === valueB));
}
exports.diffSet = diffSet;
//# sourceMappingURL=diffSet.js.map